<template>
     <div class="ideabook-recommendations-wrapper" v-if="basketItems.LatestIdeaBook && basketItems.LatestIdeaBook.IdeabookCoverImage">
        <div class="ideabook-recommendations-heading">
            <h5 class="primary-heading">{{$resourceString['myBasket.IdeaBook.Recommendations.Title']}}:</h5> 
            <p class="primary-description">{{$resourceString['myBasket.IdeaBook.Label.IdeaBook']}} {{  basketItems.LatestIdeaBook.IdeabookPublicationYear }}</p>
            <p class="primary-description">{{  basketItems.LatestIdeaBook.IdeabookName }}</p>        
        </div>
        <div class="ideabook-recommendations-details">
            <div class="ideabook-recommendations-checkbox-label">
                <input
                 type="checkbox"
                 id="add-ideabook"
                 class="custom-control-input"
                 v-model="ideaBookChecked"
                />
                <label for="add-ideabook" class="custom-control-label">
                    {{$resourceString['myBasket.IdeaBook.Label.AddIdeaBookToBasket']}}                    
                </label>
            </div>
            <div class="ideabook-recommendations-coverimage">
                <img :src="basketItems.LatestIdeaBook.IdeabookCoverImage.replace('~', '')" alt="" @error="handleImageError"/>
            </div>
        </div>
     </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { globalIcons } from "../../../constants/global";
export default {
    data() {
        return {
            ideaBookChecked: false,
            defaultImage:globalIcons.defaultImage
        };
    },
    watch:{
        getIdeaBookFlag() {
            this.ideaBookChecked = this.getIdeaBookFlag;
        },
        ideaBookChecked() {
           this.updateIdeaBookFlag(this.ideaBookChecked);
        }
    }, 
    computed: {
        ...mapGetters({
            basketItems: "newBasketPage/getBasketItems",
            getIdeaBookFlag: "newBasketPage/getIdeaBookFlag"
        })
    },
    methods: {
        ...mapActions({
            updateIdeaBookFlag: "newBasketPage/updateIdeaBookFlag"
        }),
        handleImageError(event) {
          event.target.src = this.defaultImage;
        },
    },
    mounted() {
        this.ideaBookChecked = (this.$cookies.get("ideaBook") === "true");
    }
}
</script>